module.exports = __webpack_public_path__ + "fonts/Manrope-400-greek3_f91e858.woff2";